import AxiosInterceptor from "../utils/AxiosInterceptor";
let BASE = "/emailTemplate"
const EmailTemplateList = {
    getAll: (value) => AxiosInterceptor().post(`${BASE}/getAllTemplate`  , value),
    edit: (value) => AxiosInterceptor().put(`${BASE}/updateTemplate`, value),
    //  params
    getById: (id) => AxiosInterceptor().get(`${BASE}/getOneTemplate/${id.id}`),
    add: (value) => AxiosInterceptor().post("/add-template", value),
    delete: (value) => AxiosInterceptor().post("/delete-template", value),
    sendMail: (value) => AxiosInterceptor().post("/sendEmailVal", value),
    // getDropdownLanguages: (value) =>
    // AxiosInterceptor().post("/get-all-course-entity-without-pagination", value),
};

export default EmailTemplateList;